export const mobileQuery = { query: '(max-width: 767px)' }

export const tabletQuery = { query: '(max-width: 967px)' }

export const laptopQuery = { query: '(max-width: 1224px)' }
